import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import "./style.css";
import Home from "./views/home";
import Random from "./views/random";
import Book from "./views/book";
import FAQ from "./views/faq";
import PageNotFound from "./views/page-not-found";

import PGLU from "./views/pglu";
import Selah from "./views/events/selah";
import PGLU1114 from "./views/events/pglu";
import Event from "./views/events/event";

const App = () => {
  return (
    <div>
      <Router>
        <Switch>
          {/* <Route component={Random} exact path="/randomurl" /> */}
          <Route component={Book} exact path="/book" />
          <Route component={FAQ} exact path="/faqs" />
          <Route component={Home} exact path="/" />

          <Route path="/walkin">
            <Event
              title="Walkin Form"
              event_date="19 June 2023"
              drive_url="https://docs.google.com/forms/d/e/1FAIpQLSeJmusQqOhTgx6Uu2lYlJzv-piRKEVbIN8g1qWyKFpZQ7V-2w/viewform?usp=sf_link"
            />
          </Route>

          <Route path="/pictures/selah">
            <Event
              title="Selah"
              event_date="8 November 2024"
              drive_url="https://drive.google.com/drive/folders/17XJmSfGWk2zqgNxlDU-8ZDC1FoaYn5kH?usp=drive_link"
            />
          </Route>
          <Route path="/pictures/20241114-PGLU">
            <Event
              title="PGLU"
              event_date="14 November 2024"
              drive_url="https://drive.google.com/drive/folders/1uYVwXbYxo1RTJ5GhmP_R203sxWg0zMY3?usp=drive_link"
            />
          </Route>
          <Route path="/pictures/jay-and-trina">
            <Event
              title="Jay & Trina"
              event_date="24 November 2024"
              drive_url="https://drive.google.com/drive/folders/1YfLOy8CCqXZKFYBbaGfCsZEO3N6WsX95?usp=drive_link"
            />
          </Route>
          <Route path="/pictures/patrick-and-leny">
            <Event
              title="Patrick + Leny"
              event_date="18 January 2025"
              drive_url="https://drive.google.com/drive/folders/1_U9kwKn07FVNL9nuHeJYNCQu4OHBiggI?usp=drive_link"
            />
          </Route>
          <Route path="/pictures/dmmmsu-vet-night-2025">
            <Event
              title="DMMMMSU Vet's Night"
              event_date="28 February 2025"
              drive_url="https://drive.google.com/drive/folders/1nMe1Cu15tn6_DtUqLisLqzo-UwgTKt1Q?usp=sharing"
            />
          </Route>
          <Route path="/pictures/joseph-and-gen">
            <Event
              title="Joseph & Gen"
              event_date="8 March 2025"
              drive_url="https://drive.google.com/drive/folders/1Jnrnw3vNjf8HsqopiT9lcZtWJAyAEwlN?usp=drive_link"
            />
          </Route>
          <Route path="/pictures/meet-the-molinas">
            <Event
              title="#MeetTheMolinas"
              event_date="22 March 2025"
              drive_url="https://drive.google.com/drive/folders/1DYDef9pr9x3uZjSkPrhw_sKZ_uApxjts?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/daucen-and-mikee">
            <Event
              title="Daucen & Mikee"
              event_date="24 April 2025"
              drive_url="https://drive.google.com/drive/folders/1cBJWA9e5saYwZi9I4NoGgpao0Z7PoJFm?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/john-and-geraldine">
            <Event
              title="John & Geraldine"
              event_date="26 April 2025"
              drive_url="https://drive.google.com/drive/folders/1xmm6EsumRj57QIZvM15Ewd-SUtpz8Px5?usp=sharing"
            />
          </Route>

          <Route path="/pictures/quipper">
            <Event
              title="Quipper PH"
              event_date="29 April 2025"
              drive_url="https://drive.google.com/drive/folders/1kwk6dUNY62PZrBCDsHUUMfwoeG_7n-c3?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/quipper-luzon">
            <Event
              title="Quipper Luzon"
              event_date="20 May 2025"
              drive_url="https://drive.google.com/drive/folders/1m4OHScPT3PZAuHp8eAa-m7iQCwJXzwTf?usp=sharing"
            />
          </Route>

          <Route path="/pictures/motolite">
            <Event
              title="Motolite"
              event_date="23 May 2025"
              drive_url="https://drive.google.com/drive/folders/1LIw8S-C7wQauwdDo-zaYt0fGjV2t5yLi?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/nvbsp-2025">
            <Event
              title="NVBSP 2025"
              event_date="23 July 2025"
              drive_url="https://drive.google.com/drive/folders/1nUZ4YV_mcV-kSZ-WQza-UXm1I7ERmDmy?usp=sharing"
            />
          </Route>

          <Route path="/pictures/precy-abanador">
            <Event
              title="Precy Abanador"
              event_date="2 August 2025"
              drive_url="https://drive.google.com/drive/folders/13JGFgLYiZsAG999MNbDE54xoW-zve6Ig?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/jayvee-and-sharla">
            <Event
              title="Jayvee & Sharla"
              event_date="6 September 2025"
              drive_url="https://drive.google.com/drive/folders/1LpFPa171wIkzN6fhgr1ssSZAIAeAPkx9?usp=drive_link"
            />
          </Route>

          <Route path="/pictures/lloyd-and-laarni">
            <Event
              title="Lloyd & Laarni"
              event_date="29 January 2026"
              drive_url="https://drive.google.com/drive/folders/1d0fvk4zc1PKpyQzUbfcIAtKBpkh8GK5Z?usp=drive_link"
            />
          </Route>

          <Route component={PageNotFound} path="/404" />
          <Route render={() => <Redirect to="/404" />} />
        </Switch>
      </Router>
    </div>
  );
};

ReactDOM.render(<App />, document.getElementById("app"));
